export default __webpack_public_path__ + "static/media/price-tracker.747935fa.svg";